/** A store's name with its cost-place code, so either can be searched. */
export const storeLabel = (location?: {
  name?: string;
  cost_place?: string;
} | null): string => {
  const name = location?.name?.trim();
  const code = location?.cost_place?.trim();
  if (name && code) return `${name} (${code})`;
  return name || code || "";
};
